






























































































































import { Advertisement } from "@/interfaces/advertisement";
import { MediaObject } from "@/interfaces/mediaobject";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertisement: Object as PropType<Advertisement>
  },
  computed: {
    eyecatchIndex(): number | undefined {
      for (const i of [1, 2, 3, 4, 5]) {
        const k = ("image" + i) as
          | "image1"
          | "image2"
          | "image3"
          | "image4"
          | "image5";
        if (!this.advertisement.eyeCatch) {
          continue;
        }
        if (!this.advertisement[k]) {
          continue;
        }
        const eyeCatchId = this.advertisement.eyeCatch["@id"];
        const imageId = (this.advertisement[k] as MediaObject)["@id"];
        if (eyeCatchId == imageId) {
          return i;
        }
      }
      return undefined;
    },
    mapUrl(): string {
      return (
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyC8_6QR7_VFGRPYxmtoTbbk0tCSBbI2UTY&zoom=15&q=" +
        encodeURIComponent(
          this.advertisement.mapParameters ||
            this.advertisement.storeAddress ||
            ""
        )
      );
    }
  }
});
